export default __webpack_public_path__ + "static/media/x.fa44b06c.svg";